"use client";

import React from "react";
import { Table, TableHeaderCell } from "semantic-ui-react";

/**
 * Client-safe wrapper for Semantic UI Table component.
 * Allows Table usage in Server Components by importing this shim.
 */
export function TableShim({ children, ...props }) {
  return <Table {...props}>{children}</Table>;
}

export function TableHeaderShim({ children, ...props }) {
  return <Table.Header {...props}>{children}</Table.Header>;
}

export function TableBodyShim({ children, ...props }) {
  return <Table.Body {...props}>{children}</Table.Body>;
}

export function TableRowShim({ children, ...props }) {
  return <Table.Row {...props}>{children}</Table.Row>;
}

export function TableHeaderCellShim({ children, ...props }) {
  return <TableHeaderCell {...props}>{children}</TableHeaderCell>;
}

export function TableCellShim({ children, ...props }) {
  return <Table.Cell {...props}>{children}</Table.Cell>;
}
